// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ow-1";
export var messageSideRight = "_ow-2";
export var subscribeToBackInStockBubbleContainer = "_ow-0";